export var DEFAULT_ITEM_HEIGHT = 44;
export var pickerProps = {
  title: String,
  loading: Boolean,
  readonly: Boolean,
  itemHeight: [Number, String],
  showToolbar: Boolean,
  cancelButtonText: String,
  confirmButtonText: String,
  allowHtml: {
    type: Boolean,
    default: true
  },
  visibleItemCount: {
    type: [Number, String],
    default: 6
  },
  swipeDuration: {
    type: [Number, String],
    default: 1000
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/picker/shared.js
// module id = 3UG7
// module chunks = 8